import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/components/Home";
import CheckoutSuccess from "@/components/CheckoutSuccess";
import Admin from "@/components/Admin";
import NotFound from "@/components/NotFound";
import PaymentPolicyPage from "@/components/PaymentPolicyPage";
import PricingGuidePage from "@/components/PricingGuidePage";
import OrderTrackerPage from "@/components/OrderTrackerPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/policies/payment" element={<PaymentPolicyPage />} />
          <Route path="/policies/pricing" element={<PricingGuidePage />} />
          <Route path="/track/:id" element={<OrderTrackerPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
